import React from 'react';
import './NotesDisplay.css';

const NotesDisplay = () => {
  return (
    <div className="notes-display-container">
      <h3>Notas da Consulta</h3>
      <p>As notas da consulta serão exibidas aqui.</p>
    </div>
  );
};

export default NotesDisplay;
